<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"/>
                            <span v-if="good.id">Редактирование товара</span>
                            <span v-else>Добавление товара</span>
                        </span>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Наименование</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.good.name.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"/></label>
                                    </label>
                                    <div v-if="$v.good.name.$error === true || forms.good.errors.name" class="error">
                                        {{ this.forms.good.errors.name ? this.forms.good.errors.name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Цена</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.good.price.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="glyphicon glyphicon-rub"/></label>
                                    </label>
                                    <div v-if="$v.good.price.$error === true || forms.good.errors.price" class="error">
                                        {{ this.forms.good.errors.price ? this.forms.good.errors.price.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.good.comment.$model"/>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"/>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.good.isSubmitting">
                                <span v-if="good.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Good from "../../models/Good";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {

            if (to.params.id) {
                try {
                    const good = await Good.get(to.params.id);
                    next(async component => {
                        component.good = good;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                });
            }
        },
        data() {
            return {
                good: new Good(),
                forms: {
                    good: {
                        isSubmitting: false,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            good: {
                name: {required},
                price: {},
                comment: {},
            },
        },
        methods: {
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.good.isSubmitting = true;
                this.forms.good.errors = {};

                if (this.good.id) {

                    try {
                        await this.good.update();
                    } catch (error) {
                        this.forms.good.errors = error.errors;
                    }

                } else {

                    try {
                        await this.good.add();

                        await this.$router.push({name: 'catalog-good-edit', params: {id: this.good.id}});
                    } catch (error) {
                        this.forms.good.errors = error.errors;
                    }

                }

                this.forms.good.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Товары - ' + (this.good.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
